// Generated by IcedCoffeeScript 1.7.1-e
(function () {
  exports.armor = require('./armor');
  exports.util = require('./util');
  exports.userid = require('./userid');
}).call(this);